import { Label, Switch } from '@accure/ui';

import { Tooltip } from '@/components/ui/tooltip';
import { ListTasks } from '@/task-manager/api/queries/list-tasks';
import { ViewMode } from '@/task-manager/types/view-mode';

export function ViewModeFilter({
  isProjectManagementMode,
  updateFilters,
}: {
  isProjectManagementMode: boolean;
  updateFilters: (filters: ListTasks.Filters) => void;
}) {
  return (
    <div
      className="flex flex-row items-center justify-end gap-2"
      data-testid="view-mode-filter"
    >
      <Tooltip content="View cards only relevant to project management" delay>
        <Label htmlFor="project-management-mode">Project mode</Label>
      </Tooltip>
      <Switch
        data-testid="view-mode-switch"
        id="project-management-mode"
        value={isProjectManagementMode}
        onChange={(enableProjectManagementMode) =>
          updateFilters({
            viewMode: enableProjectManagementMode
              ? ViewMode.PROJECT_MANAGEMENT
              : undefined,
          })
        }
      />
    </div>
  );
}
